export default "__VITE_ASSET__CUTAIU5H__"